import React, { useEffect, useState } from 'react';
import BackgroundActions from '../actions/BackgroundActions';

export const BackgroundImageContext = React.createContext();


const BackgroundImageProvider = (props) => {
  const [backgroundUrl, setBackgroundUrl] = useState('');

  
  const fetchBackground = async () => {
    const result = await BackgroundActions.getBackgroundImage();
    setBackgroundUrl(result);
  } 

  useEffect(() => {
    if (!backgroundUrl) {
      fetchBackground();
    }
  }, [])

  return (
    <BackgroundImageContext.Provider
    value={{
      backgroundUrl
    }}
  >
    {props.children}
  </BackgroundImageContext.Provider>
  )
}

export const Consumer = BackgroundImageContext.Consumer;
export const Provider = BackgroundImageProvider;
